import { useStore } from 'vuex'

function themeSetting(key = false) {
    const store = useStore()
    const themeSettings = store.state.global.data.theme_settings

    if (!key) {
        return themeSettings
    }

    return (themeSettings && themeSettings[key]) || false
}

export { themeSetting }
